<template>  
  <div>
    <div class="container-fluid">
      <div class="page-header filled full-block light">
        <div class="row">
          <div class="col-md-7">
            <h4 class="inline-block">{{deal.deal_title}}</h4>
          </div>
          <div class="col-md-5">
            <div class="btn-group pull-right">
              <button @click="goDeal(deal.deal_token)" class="btn btn-default"><i class="fas fa-shopping-bag"></i> 銷售管理</button>
              <button @click="goDealManagement(deal.deal_token)" class="btn btn-default active"><i class="fa fa-list-ol"></i> 專案管理</button>
              <button @click="goDealFinance(deal.deal_token)" class="btn btn-default"><i class="fas fa-dollar-sign"></i> 帳款管理</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product_drag_container">  
    	<div class="row" v-if="project.project_lists.length == 0" >
    		<div class="col-xs-12 mt-5 pt-5 text-center">
    			<h2>此專案目前沒有任何工作項目</h2>
    			<p>你可以手動建立工作項目，或從已儲存的範本匯入工作項目</p>
    			<button class="btn btn-default disable text-left" v-if="list_loading"> <span><i class="fa fa-plus"></i> 列表建立中</span></button>
		    	<button @click="addNewList()" class="btn btn-default text-left " v-else> <span><i class="fa fa-plus"></i> 新增列表</span></button>
		    	<button @click="showImportTemplateModal = true" class="btn btn-default text-left" ><i class="fas fa-file-import"></i> 從範本匯入</button>
    		</div>
    	</div>
      <Container
        orientation="horizontal"
        @drop="onColumnDrop($event)"
        drag-handle-selector=".column-drag-handle"
        @drag-start="dragStart"
        :drop-placeholder="upperDropPlaceholderOptions"
      >
        <Draggable v-for="column in project.project_lists" :key="column.id">
          <div class="project-card-container" :class="">
            <div class="project-card-column-header column-drag-handle">
              <div class="project-card-title">
                <input class="form-control" v-model="column.name" 
                  v-if="canEditColumn('column_name',column.id)"
                  @keydown.enter="$event.target.blur()" 
                  v-on:blur="finishedEditColumn();updateProjectList(column)"
                  v-bind:ref="('column_name'+column.id)"
                >
                <div class="pointer" v-else @click="editColumn('column_name',column.id)">
                	<div class="media">
                		<div class="media-body">
                			<span v-if="column.name != '' && column.name != null">{{ column.name }}</span>
                  		<span class="text-gray" v-else>新列表</span>	
    
                		</div>
                		<div v-if="column.owners" style="width:40px;" @click="editOwner(column)">
                			<img class="avatar-size avatar-size-xs project-avatar" v-for="(u,index) in column.owners" :src="u.avatar || '/static/avatar-default.jpg'" v-if="index < 2" :style="'right:'+ 10*index + 'px'">
                		</div>
                	</div>
                </div>
                <div v-if="column.start_at && column.end_at" @click="editWorkDay(column)" class="pointer">
	          			<h6 class="m-0"><small>{{column.start_at | moment_date("") }} ~ {{column.end_at | moment_date("") }} <span class="ml-2">{{column.work_days+1 }}工作天</span></small></h6>
	          		</div>		
              </div>
              <div class="dropdown pull-right">
                <button class="btn btn-default btn-more btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-caret-down"></i>
                </button>
                <ul class="dropdown-menu pointer" aria-labelledby="about-us">
                  <li><a @click="editOwner(column)" ><i class="fa fa-user"></i> 指派負責人</a></li>
                  <li><a @click="editWorkDay(column)"><i class="fa fa-calendar"></i> 制定工作日期</a></li>
                  <!-- <li><a @click="deleteProjectList(column)"><i class="fa fa-trash"></i> 刪除列表</a></li> -->
                  <li><a @click="temp_list = column;temp_list.delete_alert = true"><i class="fa fa-trash"></i> 刪除列表</a></li>
                </ul>
              </div>
            </div>
            <div class="project-card-box" v-bind:ref="('project-card-box'+column.id)">
              <Container
                group-name="col"
                @drop="(e) => onCardDrop(column.id, e)"
                @drag-start="(e) => log('drag start', e)"
                @drag-end="(e) => log('drag end', e)"
                :get-child-payload="getCardPayload(column.id)"
                drag-class="project-card-ghost"
                drop-class="project-card-ghost-drop"
                :drop-placeholder="dropPlaceholderOptions"
              >
                <Draggable v-for="card in column.project_cards" :key="card.id">
                  <div class="project-card" v-bind:class="card.label">
                    <div class="card-title" v-bind:class="{'has-checkbox':card.project_card_lists.length == 0}">
                      <input v-if="card.project_card_lists.length == 0" class="input-success pointer" type="checkbox" v-model="card.is_done" @change="updateCard(card)">
                      <p v-if="card.name!=''" class="margin-0 pointer" @click="showCard(card)">{{ card.name }}</p>
                      <p v-else class="margin-0 pointer text-gray" @click="showCard(card)">新卡片</p>
                    </div>
                    <div  @click="showCard(card)" class="project-card-info pointer">
                      <div class="item-info">
                        <span v-if="card.project_card_lists.length > 0" class="mr-3" v-bind:class="{'btn btn-success btn-xs': doneItemsFromCards(card.project_card_lists) == totalItemsFromCards(card.project_card_lists)}">
                          <i class="fa fa-list"></i> {{doneItemsFromCards(card.project_card_lists)}}/{{totalItemsFromCards(card.project_card_lists)}}
                        </span>
                        <span class="mr-3" v-if="card.project_card_comments.length != 0">
                          <i class="far fa-comment-alt"></i> {{ card.project_card_comments.length }}
                        </span>
                      </div>
                    </div>
                  </div>
                </Draggable>
                <div class="project-card" v-if="add_new_card == column.id">
                  <input class="form-control no-border-input" v-bind:ref="('new_card_input'+column.id)" type="input" v-model="temp_card.name" placeholder="請為這個卡片增加標題" @keydown.enter="addNewCard(column.id)" @keydown.esc="resetTempCard()">
                  <button @click="addNewCard(column.id)" class="btn btn-success btn-sm"><i class="fa fa-check"></i></button>
                  <button @click="add_new_card = ''" class="btn btn-default btn-white btn-sm"><i class="fa fa-times"></i></button>
                </div>
              </Container>
            </div>
            <div @click="add_new_card = column.id;editColumn('new_card_input',column.id);scrollBottom('project-card-box',column.id)" class="text-center add_new_card pointer"><i class="fa fa-plus"></i> 新增卡片</div>
          </div>
        </Draggable>
        <span style="width:10px;display:inline-block"></span>
      </Container>
      <!-- modal template start -->
      <div v-if="showCardModal" @keydown.esc="showCardModal=false;resetTempCard()" tabindex="0">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="showCardModal=false;resetTempCard()">
            <div class="modal-container col-md-6" @click.stop>
              <div class="modal-header" style="min-height: 0px;">
                <a class="btn-close" @click="showCardModal = false;resetTempCard()">
                  <i class="zmdi zmdi-close"></i>
                </a>
              </div>
              <div class="modal-body row j-forms card-show-content" style="padding:0 0 10px 0;max-height: 85vh;">
                <div class="card-main-area col-md-9">
                  <input class="form-control" v-model="temp_card.name" 
                    v-if="canEditColumn('card_name',temp_card.id)"
                    @keydown.enter="$event.target.blur()" 
                    v-on:blur="updateCard(temp_card)"
                    v-bind:ref="('card_name'+temp_card.id)"
                  >
                  <h4 class="pointer bold500" v-else @click="editColumn('card_name',temp_card.id)">
                    <span v-if="temp_card.name != ''">{{ temp_card.name }}</span>
                    <span class="text-gray" v-else>新卡片</span>
                  </h4>
                  <h5 class="bold500"><i class="fas fa-align-justify"></i> 描述</h5>
                  <div class="">
                    <textarea v-autosize="temp_card.description" rows=3  style="margin-bottom:5px;" class="form-control" v-model="  temp_card.description" 
                      v-if="canEditColumn('card_description',temp_card.id)"
                      v-on:blur="updateCard(temp_card)"
                      v-bind:ref="('card_description'+temp_card.id)">{{temp_card.description}}
                    </textarea>
                    <div v-if="canEditColumn('card_description',temp_card.id)==false && temp_card.description!=''" @click="editColumn('card_description',temp_card.id)" class="pre well well-sm pointer text-gray">{{temp_card.description}}</div>
                    <div v-if="canEditColumn('card_description',temp_card.id)==false && temp_card.description==''" @click="editColumn('card_description',temp_card.id)" class="pre well well-sm pointer text-gray">你可以為這張卡片加上詳細的描述...</div>
                  </div>
                  <hr v-if="temp_card.project_card_lists.length != 0">
                  <div class="form-group">
                    <Container
                      @drop="onListDrop($event)"
                      lock-axis="y"
                      :drop-placeholder="dropPlaceholderOptions"
                    >
                      <Draggable class="item-lists" v-for="list in temp_card.project_card_lists" :key="list.id">
                  
                        <input style="margin-bottom:5px;" class="form-control" v-model="list.content" 
                          v-if="canEditColumn('list_content',list.id)"
                          @keydown.enter="$event.target.blur()" 
                          v-on:blur="updateCardList(list)"
                          v-bind:ref="('list_content'+list.id)"
                        >
                        <div class="media" v-else>
			                  	<div class="media-body">
			                  		<h5 class="pointer bold500" @click="temp_card_list = list;editColumn('list_content',list.id)">
		                          <i class="fa fa-list"></i> 
		                          <span v-if="list.content == '' || list.content == null">新分類名稱</span>
		                          <span v-else>{{list.content}}</span>
		                        </h5>
			                  	</div>
			                  	<button @click="deleteProjectCardList(list)" class="btn btn-default align-self-center btn-xs mr-1"><i class="fa fa-times"></i></button>
			                  </div>
                        <div class="progress">
                          <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="70"
                          aria-valuemin="0" aria-valuemax="100" v-bind:style="'width:' + doneItems(list.project_card_list_items).length*100/list.project_card_list_items.length + '%'">
                            <span class="sr-only">{{doneItems(list.project_card_list_items)*100/list.project_card_list_items.length}}% Complete</span>
                          </div>
                        </div>
                        <div class="item-list">
                          <Container
                            group-name="item"
                            @drop="(e) => onItemDrop(list.id, e)"
                            @drag-start="(e) => log('drag start', e)"
                            @drag-end="(e) => log('drag end', e)"
                            :get-child-payload="getItemPayload(list.id)"
                            lock-axis="y"
                            :drop-placeholder="dropItemPlaceholderOptions"
                          >
                            <Draggable class="single-item" v-for="item in list.project_card_list_items" :key="item.id">
                              <div class="media-left">
                                <input @change="updateCardListItem(item)" type="checkbox" class="input-success pointer" v-model="item.is_done">
                              </div>
                              <div class="media-body">
                                <input class="form-control" v-bind:ref="('item_content'+item.id)" v-model="item.content" 
                                  v-if="canEditColumn('item_content',item.id)"
                                  @keydown.enter="$event.target.blur()" 
                                  v-on:blur="updateCardListItem(item)"
                                >
                                <p class="pointer relative pr-5" v-else>
                                	<span @click="editColumn('item_content',item.id)" class="btn-block" v-if="item.content == null">新項目</span>
                                  <span @click="editColumn('item_content',item.id)" class="btn-block" v-else>{{item.content}}</span>
                                  <button @click="deleteListItem(list,item)" style="right: 2px;top:2px; position:absolute;" class="btn btn-default btn-xs"><i class="fa fa-times"></i></button>
                                </p>
                              </div>
                            </Draggable>
                          </Container>
                          <button v-if="list.loading != true" style="margin-top:5px;" @click="addNewCardListItem(list)" class="btn btn-gray"><i class="fa fa-plus"></i> 增加項目</button>
                          <button v-else style="margin-top:5px;" class="btn btn-gray"><i class="fas fa-spinner"></i> 項目建立中</button>
                        </div>
                      </Draggable>
                    </Container>
                  </div>
                  <hr>
                  <h5><i class="far fa-comment-alt"></i> 留言 ({{temp_card.project_card_comments.length}})</h5>
                  <div class="card-comment-textarea media">
                    <img class="avatar-size" v-bind:src="user.profile_pic || '/static/avatar-default.jpg'">
                    <div class="media-body">
                      <textarea class="form-control" v-model="temp_comment.content" placeholder="你可以在此留言...">{{temp_comment.content}}</textarea>
                      
                      <button v-if="temp_comment.loading" style="margin:10px 0px;" class="btn btn-default disabled">
                        建立中..
                      </button>
                      <button v-else style="margin:10px 0px;" class="btn btn-default" @click="addNewComment()">
                        新增留言
                      </button>
                    </div>
                  </div>
                  <div class="single-card-comment" v-for="comment in temp_card.project_card_comments">
                  	<div class="media">
                  		<img class="avatar-size" v-bind:src="comment.user_avatar || '/static/avatar-default.jpg'">
                  		<div class="media-body">
                  			<div class="card-message-box">{{comment.content}}</br><small>{{comment.created_at | moment("dddd, MMMM Do YYYY")}}</small></div>
                  		</div>
                  	</div>
                  </div>
                  
                </div>
                <div class="card-main-area col-md-3">
                  <button v-if="temp_card_list.loading != true" class="btn btn-default btn-block" @click="addNewCardList()">
                    <i class="fa fa-plus"></i> 增加更多事項
                  </button>
                  <button class="btn btn-default btn-block disable" v-else><i class="fas fa-spinner"></i> 事項分類建立中..</button>

                  <button v-if="temp_card.project_card_lists.length == 0 && temp_card.project_card_comments.length == 0" class="btn btn-default btn-block" @click="deleteProjectCard()"><i class="fa fa-trash"></i> 刪除卡片</button>

                  <button v-else class="btn btn-default btn-block" @click="temp_card.delete_alert=true"><i class="fa fa-trash"></i> 刪除卡片</button>

                  <div v-if="temp_card.delete_alert == true">
                  	<p class="mt-3">你確定要刪除這個卡片？這個動作將會同時刪除卡片內的所有分類、項目、與資料</p>
                  	<button class="btn btn-default btn-danger" @click="deleteProjectCard()">確認刪除</button>
                  	<button class="btn btn-default" @click="temp_card.delete_alert=false">取消</button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showOwnersModal" @keydown.esc="showOwnersModal=false" tabindex="0">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="showOwnersModal=false">
            <div class="modal-container col-md-6" @click.stop>
              <div class="modal-header" style="min-height: 0px;">
                <a class="btn-close" @click="showOwnersModal = false;">
                  <i class="zmdi zmdi-close"></i>
                </a>
              </div>
              <div class="modal-body row j-forms" style="padding:0 0 10px 0;max-height: 85vh;">
            		<div class="col-md-12">
            			<h4 class="text-center">指派此項目的負責人</h4>
            		</div>
            		<div class="col-md-6">
            			<h5 class="text-center">參與的人員</h5>
            			<div class="card">
            				<div class="card-body">
            					<div v-for="user in temp_list.owners" class="p-3 pointer" @click="removeOnwer(user)">
            						<div class="media">
            							<img class="img-thumbnail img-circle avatar-size avatar-size-md" :src="user.avatar || '/static/avatar-default.jpg'">
            							<div class="media-body align-self-center">
            								<span>{{user.name}}</span>
            								<span class="pull-right"><i class="fa fa-times"></i></span>
            							</div>
            						</div>
            					</div>
            					<div class="py-5 px-3 text-center" v-if="temp_list.owners.length == 0">目前無負責人員，請點擊右側清單即可增加</div>
            				</div>
            			</div>
            		</div>
            		<div class="col-md-6">
            			<h5 class="text-center">公司人員</h5>
            			<input class="form-control mb-2" placeholder="輸入姓名過濾" v-model="user_keyword">
            			<div class="card" v-if="filterCompanyUsers.length > 0">
            				<div class="card-body">
            					<div v-for="user in filterCompanyUsers" class="p-3 pointer" @click="addOwner(user)">
            						<div class="media">
            							<img class="img-thumbnail img-circle avatar-size avatar-size-md" :src="user.avatar || '/static/avatar-default.jpg'">
            							<div class="media-body align-self-center">
            								<span>{{user.name}}</span>
            								<span class="pull-right"><i class="fa fa-plus"></i></span>
            							</div>
            						</div>
            					</div>
            				</div>
            			</div>
            			<div class="py-5 px-3 text-center" v-else>無成員</div>
            		</div>
            	</div>
          	</div>
          </div>
        </div>
      </div>
      <div v-if="showDateChooseModal" @keydown.esc="showDateChooseModal=false" tabindex="0">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="showDateChooseModal=false">
            <div class="modal-container col-md-7" @click.stop>
              <div class="modal-header" style="min-height: 0px;">
                <a class="btn-close" @click="showDateChooseModal = false;">
                  <i class="zmdi zmdi-close"></i>
                </a>
              </div>
              <div class="modal-body row modal-calendar" style="padding:0 0 10px 0;max-height: 85vh;">
            		<div class="col-md-12 text-center">
            			<h4 class="text-center">選擇工作日期</h4>
          				<date-range-picker
				            ref="picker"
				            opens="inline"
				            :locale-data="dateRangeOption"
				            :showWeekNumbers="false"
				            :show-dropdowns="true"
				            :autoApply="true"
				            v-model="dateRange"
				            @update="updateDatepicker"
				            :linkedCalendars="true"
				            :ranges="range"
						    	>
							    </date-range-picker>
            			<p class="p-5 text-center" v-if="temp_list.start_at && temp_list.end_at">{{temp_list.start_at | moment_date("") }} ~ {{temp_list.end_at | moment_date("") }} <i class="fa fa-times" @click="removeDateTime()"></i></p>
            		</div>
            	</div>
          	</div>
          </div>
        </div>
      </div>
      <div v-if="temp_list.delete_alert == true" @keydown.esc="temp_list.delete_at=false" tabindex="0">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="temp_list.delete_at=false">
            <div class="modal-container col-md-7" @click.stop>
              <div class="modal-header" style="min-height: 0px;">
                <a class="btn-close" @click="temp_list.delete_at = false;">
                  <i class="zmdi zmdi-close"></i>
                </a>
              </div>
              <div class="modal-body row modal-calendar" style="padding:0 0 10px 0;max-height: 85vh;">
            		<div class="col-md-12 text-center">
            			<h4 class="text-center">你確定刪除『{{temp_list.name}}』嗎？</h4>
          				<p class="text-center">這個動作將會刪除此列表以及他所有的卡片</p>
          				<div class="text-center">
          					<button class="btn btn-danger" @click="deleteProjectList(temp_list)">確定刪除</button>
          					<button class="btn btn-default" @click="resetTempList()">取消</button>
          				</div>
            		</div>
            	</div>
          	</div>
          </div>
        </div>
      </div>
      <div v-if="showSaveTemplateModal" @keydown.esc="showSaveTemplateModal=false" tabindex="0">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="showSaveTemplateModal=false">
            <div class="modal-container col-md-7" @click.stop>
              <div class="modal-header" style="min-height: 0px;">
                <a class="btn-close" @click="showSaveTemplateModal = false;">
                  <i class="zmdi zmdi-close"></i>
                </a>
              </div>
              <div class="modal-body row" style="padding:0 0 10px 0;max-height: 85vh;">
            		<div class="col-md-12 text-center jutify-content-center">
  								<div class="row">
  									<div class="col-md-4 text-left align-self-center">
  										<h4 class="text-center bold">儲存為工作範本</h4>
  										<p>工作範本是flowneat裡面獨特且強大的功能之一</p>
  										<p>你可以將一個常態性的工作流程仔細規劃之後，將此工作流程儲存為範本SOP，flowneat範本會紀錄工作項目、工作天數</p>
  										<p>當你未來遇到同樣類型的工作，直接匯入範本，將可以大幅降低規劃所需的時間！</p>
  									</div>
  									<div class="col-md-8 align-self-center">
  										<div class="media">
  											<div class="media-body">
  												<input class="form-control" placeholder="新範本名稱" v-model="temp_template.name">
  											</div>
  											<button v-if="temp_template.loading==false" @click="saveProjectTemplate()" class="btn btn-primary ml-3">儲存為新範本</button>
  											<button v-else class="btn btn-primary ml-3 disabel">儲存中...</button>
  										</div>
  										<hr>
											<p class="alert alert-info" v-if="project_templates.length == 0">你目前沒有範本，請從上方輸入範本名稱，flowneat會將這個專案的工作列表儲存為新範本</p>
											<div v-else class="template-modal-content">
												<div class="card p-2 mb-3" v-for="template in project_templates">
													<div class="card-body">
														<div class="row">
															<div class="col-xs-5 text-left pointer">
																<input class="form-control" v-bind:ref="('template_name'+template.id)" v-model="template.name" 
                                  v-if="canEditColumn('template_name',template.id)"
                                  @keydown.enter="$event.target.blur()" 
                                  v-on:blur="updateTemplate(template,'name')"
                                >
                                <div v-else @click="editColumn('template_name',template.id)">
																	<i class="fas fa-pencil-alt"></i> {{template.name}}
																</div>
															</div>
															<div class="col-xs-5 text-left">
																<span class="mr-2" v-if="template.project_lists_amount != 0">
																	列表：{{template.project_lists_amount}}
																</span>
																<span class="mr-2" v-if="template.project_cards_amount != 0">
																	卡片：{{template.project_cards_amount}}
																</span>
																<span class="mr-2" v-if="template.project_card_list_items_amount != 0">
																	項目：{{template.project_card_list_items_amount}}
																</span>
																<span class="mr-2" v-if="template.work_days != 0">
																	總工作天：{{template.work_days}}
																</span>
															</div>
															<div class="col-xs-2 text-right">
																<button v-if="template.save_alert==false" @click="template.save_alert=true" class="btn btn-default btn-xs">
																	<i class="fas fa-save"></i>
																</button>
																<button v-if="template.delete_alert==false" @click="template.delete_alert=true" class="btn btn-default btn-xs">
																	<i class="fas fa-trash"></i>
																</button>
															</div>
															<div v-if="template.save_alert==true" class="col-md-12">
																<p class="mt-2"> 
																	你確定將『{{deal.deal_title}}』的工作項目覆蓋於『範本-{{template.name}}』嗎?
																	<br>
																	<button @click="updateTemplate(template,'template')" class="btn btn-danger btn-sm"><i class="fas fa-save"></i> 確定</button> 
																	<button @click="template.save_alert = false" class="btn btn-default btn-sm"><i class="fa fa-times"></i> 取消</button>
																</p>
															</div>
															<div v-if="template.delete_alert==true" class="col-md-12">
																<p class="mt-2"> 
																	你確定將『範本-{{template.name}}』刪除嗎?
																	<br>
																	<button @click="deleteTemplate(template)" class="btn btn-danger btn-sm"><i class="fas fa-trash"></i> 確定刪除</button> 
																	<button @click="template.delete_alert = false" class="btn btn-default btn-sm"><i class="fa fa-times"></i> 取消</button>
																</p>
															</div>
														</div>
													</div>
												</div>
											</div>
  									</div>
  								</div>
            		</div>
            	</div>
          	</div>
          </div>
        </div>
      </div>
      <div v-if="showImportTemplateModal" @keydown.esc="showImportTemplateModal=false" tabindex="0">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="showImportTemplateModal=false">
            <div class="modal-container col-md-7" @click.stop>
              <div class="modal-header" style="min-height: 0px;">
                <a class="btn-close" @click="showImportTemplateModal = false;">
                  <i class="zmdi zmdi-close"></i>
                </a>
              </div>
              <div class="modal-body row" style="padding:0 0 10px 0;max-height: 85vh;">
            		<div class="col-md-12 text-center jutify-content-center">
  								<div class="row">
  									<div class="col-md-12 align-self-center">
  										<h4 class="text-center bold">匯入工作範本</h4>
  										<p>輕輕一點，輕鬆建立工作項目，大幅降低你的規劃時間 :)</p>
  										<div class="row justify-content-center">
  											<div class="col-md-6">
  												<span class="align-self-center mr-3">工作起始日期</span>
  												<datepicker input-class="form-control" v-model="template_start_date" :format="customFormatter" language="zh"></datepicker>
  											</div>
  										</div>
  										<hr>
  									</div>

  									<div class="col-md-12 align-self-center">
											<p v-if="project_templates.length == 0">
												您目前沒有範本，請先點擊以下按鈕建立範本
												<button @click="resetTempTemplate();showImportTemplateModal=false;showSaveTemplateModal=true;" class="btn btn-default text-left" ><i class="fa fa-save"></i> 儲存新範本</button>
											</p>
											<div v-else class="template-modal-content row">
												<div class="col-md-4" v-for="template in project_templates">
													<div class="card p-2 mb-3">
														<div class="card-body">
															<h4>{{template.name}}</h4>
															<span class="mr-2" >
																列表：{{template.project_lists_amount}}
															</span>
															<span class="mr-2">
																卡片：{{template.project_cards_amount}}
															</span>
															<span class="mr-2">
																項目：{{template.project_card_list_items_amount}}
															</span>
															<br>
															<span class="mr-2" v-if="template.work_days != 0">
																總工作天：{{template.work_days}}
															</span>
															<div>
																<button v-if="template.loading==false && template.import_alert==false" @click="template.import_alert=true" class="btn btn-default btn-xs">
																	<i class="fas fa-file-import"></i> 匯入
																</button>
																<div class="alert alert-info" v-if="template.import_alert==true">
																	<p class='mt-3'>匯入新範本將會取代此專案的所有工作項目</p>
																	<button @click="template.import_alert=false;importTemplate(template)" class="btn btn-danger btn-xs">
																		<i class="fas fa-file-import"></i> 確定匯入
																	</button>
																	<button @click="template.import_alert=false" class="btn btn-default btn-xs">
																		<i class="fas fa-file-import"></i> 取消
																	</button>
																</div>
																<button v-if="template.loading==true" class="btn btn-default btn-xs disable">匯入中..</button>
															</div>
														</div>
													</div>
												</div>
											</div>
  									</div>
  								</div>
            		</div>
            	</div>
          	</div>
          </div>
        </div>
      </div>
      <!-- modal template end-->
      <simplert :useRadius="true" :useIcon="true" ref="simplert">
      </simplert>
    </div>
    <div class="project_control_container">
    	<button class="btn btn-default btn-block disable text-left" v-if="list_loading"> <span><i class="fa fa-plus"></i> 列表建立中</span></button>
    	<button @click="addNewList()" class="btn btn-default text-left btn-block" v-else> <span><i class="fa fa-plus"></i> 新增列表</span></button>
    	<hr>
    	<button @click="resetTempTemplate();showSaveTemplateModal=true" class="btn btn-default text-left btn-block" ><i class="fa fa-save"></i> 儲存為範本</button>
    	<button @click="showImportTemplateModal = true" class="btn btn-default text-left btn-block" ><i class="fas fa-file-import"></i> 從範本匯入</button>
    	<!-- <hr>
    	<button class="btn btn-default text-left btn-block" ><i class="fas fa-stream"></i> 檢視甘特圖</button>
    	<button class="btn btn-default text-left btn-block" ><i class="fas fa-file-contract"></i> 檢視結構圖</button> -->
    </div>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert';
import moment from 'moment';
import dealHeader from '../Deals/DealHeader';
import DateRangePicker from 'vue2-daterange-picker'
import Datepicker from 'vuejs-datepicker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag, generateItems } from '../../utils/dragHelpers'
import { getArrayItemById, getArrayItem } from '../../utils/commonHelpers'


export default {
  name: 'project_management_board',
  data() {
  	let today = new Date()
		// today.setHours(0, 0, 0, 0)

		let yesterday = new Date()
		yesterday.setDate(today.getDate() - 1)
		// yesterday.setHours(0, 0, 0, 0);

		let tomorrow = new Date()
		tomorrow.setDate(today.getDate() + 1)
		// tomorrow.setHours(0, 0, 0, 0);

		let next_week = new Date()
		next_week.setDate(today.getDate() + 6)
		// next_week.setHours(0, 0, 0, 0);
		
    return {
      refs: this.$refs,
      list_loading: false,
      showOwnersModal: false,
      showDateChooseModal: false,
      showCardModal: false,
      showSaveTemplateModal: false,
      showImportTemplateModal: false,
      editListTitle: false, 
      template_start_date: new Date(),
      project_templates:[],
      editColumnName: "",
      editColumnId: "",
      temp_list:{},
      temp_card:{},
      temp_comment:{},
      temp_card_list:{},
      add_new_card: "",
      temp_new_card: "",
      temp_template: {},
      user_token: '',
      user_avatar: '',
      upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropPlaceholderOptions: {
        className: 'drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropItemPlaceholderOptions: {
        className: 'drop-item-preview',
        showOnTop: true
      },
      dateRangeOption: {
		    format: 'yyyy/mm/dd',
		    separator: ' - ',
		    applyLabel: '確定',
		    cancelLabel: '取消',
		    weekLabel: '週',
		    customRangeLabel: '自訂工作區間',
		    daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
		    monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
		    firstDay: 0
			},
    	dateRange: {
				startDate: null,
				endDate: null
			},
    	user_keyword: "",
    	range: {
		    '今天': [today, today],
		    '昨天': [yesterday, yesterday],
		    '明天': [tomorrow, tomorrow],
		    '一週': [today, next_week],
		    '這個月': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth()+ 1, 0)],
		    '上個月': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
		    '今年': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
			}
    }
  },
  components: {
    Simplert,dealHeader,Container, Draggable ,DateRangePicker, Datepicker
  },
  created() {
    this.resetTempList()
    this.resetTempCard()
    this.resetTempCardList()
    this.resetTempComment()
    this.resetTempTemplate()
    this.getDeal(this.$route.params.deal_token)
    this.getProject(this.$route.params.deal_token)
    this.getProjectTemplate(this.$route.params.deal_token)
  },
  props: ['project','deal','user'],
  computed: {
  	filterCompanyUsers: function(){
  		let vm = this
  		let result = []
  		let user_ids = vm.temp_list.owners.map(function(e) {
		    return e.user_token;
		  })
  		$.each(vm.project.company_users,function(i,e){
  			if(!user_ids.includes(e.user_token)){
  				if(vm.user_keyword =="" || e.name.toLowerCase().includes(vm.user_keyword.toLowerCase())){
  					result.push(e)
  				}
  			}
  		})
  		return result
  	},
  },
  methods: {
  	customFormatter(date) {
    	moment.locale('zh-tw');
      return moment(date).format('YYYY MMM Do');
    },
    getDeal(deal_token) {
      if(deal_token != ''){
        this.auth_token = { 'Auth-Token': getCookie('auth_token') }
        const vm = this;
        this.axios.get('deals/show', {
          params: {
            'deal': { 'deal_token': deal_token },
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.user_token = response['data']['data']['user_token']
            vm.user_avatar = response['data']['data']['user_avatar']
            var deal = response['data']['data']['deal']
            vm.$emit("update-deal", deal);
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
      }
    },
    getProject(deal_token) {
      if(deal_token != ''){
        this.auth_token = { 'Auth-Token': getCookie('auth_token') }
        const vm = this;
        this.axios.get('projects', {
          params: {
            'deal_token': deal_token ,
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            var project = response['data']['data']['project']
            project.company_users = response['data']['data']['company_users']
            vm.$emit("update-project", project);
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
      }
    },
    getProjectTemplate(deal_token){
    	if(deal_token != ''){
        this.auth_token = { 'Auth-Token': getCookie('auth_token') }
        const vm = this;
        this.axios.get('projects/project_templates', {
          params: {
            'deal_token': deal_token ,
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            var project = response['data']['data']['project']
            vm.project_templates = response['data']['data']['current_collection']
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
      }
    },
    saveProjectTemplate(){
    	let vm=this
    	if(vm.temp_template.name=='' || vm.temp_template == null){
    		vm.$toastr.w(
		      "請填寫範本名稱"
		    );
		    return
    	}

    	if(vm.project.project_lists.length == 0){
    		vm.$toastr.w(
		      "目前所在的專案，沒有任何的工作項目可以儲存為範本唷！請先手動建立工作項目再回來儲存 :)"
		    );
		    return
    	}

  		vm.temp_template.loading = true
    	this.axios.post('projects/project_templates', {
        deal_token: vm.$route.params.deal_token,
        project_template: vm.temp_template,
        content: vm.project.project_lists,
      })
      .then(function(response) {
      	console.log(response.status,response['data']['status'])
        if(response.status == 200 && response['data']['status']== 'success'){
          vm.temp_template.loading = false
          vm.project_templates.push(response['data']['data']['current_object'])
          vm.$emit("update-project", vm.project);

        } else {
        	vm.temp_template.loading = false
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
      	vm.temp_template.loading = false
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
		    );
      });

    },
    updateTemplate(template,update_type){
    	let vm = this
    	vm.finishedEditColumn()
    	this.axios.put('projects/project_templates/'+template.id, {
        deal_token: vm.$route.params.deal_token,
        project_template: template,
        update_type: update_type,
        content: vm.project.project_lists,
      })
      .then(function(response) {
      	console.log(response.status,response['data']['status'])
        if(response.status == 200 && response['data']['status']== 'success'){
        	if(update_type=='template'){
        		template.project_lists_amount = response['data']['data']['current_object']['project_lists_amount']
        		template.project_cards_amount = response['data']['data']['current_object']['project_cards_amount']
        		template.project_card_list_items_amount = response['data']['data']['current_object']['project_card_list_items_amount']
        		template.save_alert = false
        		vm.$toastr.s(
				      "範本覆蓋成功"
				    );
        	}
        } else {
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
		    );
      });
    },
    importTemplate(template){
    	let vm=this
    	if(vm.template_start_date=='' || vm.template_start_date == null){
    		vm.$toastr.w(
		      "請選擇工作開始日期"
		    );
		    return
    	}

  		template.loading = true

    	this.axios.post('projects/project_templates/import_template', {
        deal_token: vm.$route.params.deal_token,
        id: template.id,
        start_date: vm.template_start_date,
      })
      .then(function(response) {
      	console.log(response.status,response['data']['status'])
        if(response.status == 200 && response['data']['status']== 'success'){
          // const project = Object.assign({}, vm.project)
          var project = response['data']['data']['current_object']
          vm.$emit("update-project", project);
          vm.$toastr.s(
			      "匯入完成"
			    );
			    template.loading = false
        } else {
        	template.loading = false
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
      	template.loading = false
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
		    );
      });
    },
    deleteTemplate(template){
      let vm = this
      this.axios.delete('projects/project_templates/'+template.id, {
        params: {
          deal_token: vm.$route.params.deal_token,
        }
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
          var index = vm.project_templates.indexOf(template)
      		vm.project_templates.splice(parseInt(index), 1)
          vm.$emit("update-project", vm.project);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    resetTempList(){
      this.temp_list = {
        id: '',
        name: '',
        project_cards: [],
        delete_alert: false,
      }
    },
    resetTempCard(){
      this.temp_card = {
        id: '',
        name: '',
        is_done: false,
        done_time: '',
        project_list_id: '', 
        project_card_lists: [],
        delete_alert: false,
      }
      this.add_new_card = ''
    },
    resetTempTemplate(){
    	this.temp_template = {
    		id: '',
    		name: '',
    		content: this.project.project_lists,
    		project_list_amount: '',
    		project_cards_amount: '',
    		project_card_lists_amount: '',
    		project_card_list_items_amount: '',
    		loading: false,
    	}
    },	
    scrollBottom(name,id){
    	this.$refs[name+id][0].scrollTop = 9999
    },
    showCard(card){
    	this.resetTempCard()
    	this.resetTempComment()
      this.temp_card = card
      this.temp_comment.project_card_id = card.id
      this.showCardModal = true
    },
    canEditColumn(colmn_name,id){
      let vm = this
      if(vm.editColumnName == colmn_name && vm.editColumnId == id){
        return true
      }else{
        return false
      }
    },
    editColumn(name,id){
      let vm = this
      this.editColumnName = name
      this.editColumnId = id
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[name+id])){
          vm.$refs[name+id][0].focus()
        }else{
          vm.$refs[name+id].focus()
        }
      })
    },
    finishedEditColumn(){
      this.editColumnName = ""
      this.editColumnId = ""
    },
    
    editOwner(item){
    	let vm = this
    	vm.temp_list = item
    	vm.showOwnersModal = true
    },
    addOwner(user){
    	let vm = this
    	vm.temp_list.owners.push(user)
    	vm.updateProjectList(vm.temp_list)
    },
    removeOnwer(user){
    	let vm = this
    	var index = vm.temp_list.owners.indexOf(user)
      vm.temp_list.owners.splice(parseInt(index), 1)
      vm.updateProjectList(vm.temp_list)
    },
    updateDatepicker(){
    	let vm = this
    	vm.temp_list.start_at = vm.dateRange.startDate
    	vm.temp_list.end_at = vm.dateRange.endDate
    	vm.updateProjectList(vm.temp_list)
    },
    removeDateTime(){
    	this.temp_list.start_at= null; 
    	this.temp_list.end_at= null; 
    	this.dateRange = {
				startDate: null,
				endDate: null
			}
    	this.updateProjectList(this.temp_list)
    },
    editWorkDay(list){
    	this.temp_list = list
    	var date = new Date();
    	// if(!list.start_at){
    	// 	list.start_at = date
    	// 	list.end_at = new Date(date.getTime() + 86400000);
    	// } 
    	this.dateRange= {
				startDate: list.start_at,
				endDate: list.end_at,
			},
    	this.showDateChooseModal=true
    },
    addNewCard(column_id){
      let vm = this
      const project = Object.assign({}, this.project)
      vm.temp_card.project_list_id = column_id

      this.axios.post('projects/project_cards', {
        deal_token: vm.$route.params.deal_token,
        project_list_id: column_id,
        project_card: vm.temp_card
      })
      .then(function(response) {
        if (response.status == 200) {
          let list = getArrayItemById(project.project_lists,column_id)
          var new_card = response['data']['data']['current_object']
          list.project_cards.push(new_card)
          vm.resetTempCard()
          vm.$emit("update-project", project);
          let add_new_card = ''
        } else {
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
		    );
      });
    },
    updateCard(card){
    	let vm = this
    	vm.finishedEditColumn()
    	this.axios.put('projects/project_cards/'+card.id, {
        project_list_id: card.project_list_id,
        deal_token: vm.$route.params.deal_token,
        project_card: card,
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.$emit("update-project", vm.project);
        } else {
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
		    );
      });
    },
    resetTempCardList(){
    	this.temp_card_list = {
        id: '',
        name: '新分類',
        project_card_id: '',
        project_card_list_items: [],
        loading: false,
        delete_alert: false,
      }
    },
    addNewCardList(){
      let vm = this 
      vm.resetTempCardList()
      vm.temp_card_list.project_card_id = vm.temp_card.id
      vm.temp_card_list.loading = true
      this.axios.post('projects/project_card_lists', {
        deal_token: vm.$route.params.deal_token,
        project_card_list: vm.temp_card_list
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.temp_card_list = response['data']['data']['current_object']
          vm.temp_card.project_card_lists.push(vm.temp_card_list);
      		vm.editColumn('list_content',vm.temp_card_list.id)
          // vm.editColumn('column_name',new_list.id)
          vm.resetTempCardList()
          // vm.list_loading = false;
          vm.$emit("update-project", vm.project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
      //wait ajax
    },
    updateCardList(list){
    	let vm = this
    	vm.finishedEditColumn()
    	this.axios.put('projects/project_card_lists/'+list.id, {
        deal_token: vm.$route.params.deal_token,
        project_card_list: list,
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.$emit("update-project", vm.project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });

    },
    addNewCardListItem(list){
      let vm = this 
      list.loading = true
      let item = {
      	project_card_list_id: list.id
      }

      this.axios.post('projects/project_card_list_items', {
        deal_token: vm.$route.params.deal_token,
        project_card_list_item: item
      })
      .then(function(response) {
        if (response.status == 200) {
        	var new_item = response['data']['data']['current_object']
          list.project_card_list_items.push(new_item)
          list.loading = false
		      vm.editColumn('item_content',parseInt(new_item['id']))
		      const project = Object.assign({}, vm.project)
		      vm.$emit("update-project", project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });

      
    },
    updateCardListItem(item){
    	let vm = this
      this.axios.put('projects/project_card_list_items/'+item.id, {
        project_card_list_item: item,
        deal_token: vm.$route.params.deal_token,
      })
      .then(function(response) {
        if (response.status == 200) {
        	vm.finishedEditColumn()
          vm.$emit("update-project", vm.project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    deleteProjectCardList(project_card_list){
      let vm = this
      this.axios.delete('projects/project_card_lists/'+project_card_list.id, {
        params: {
          deal_token: vm.$route.params.deal_token,
          project_card_list: project_card_list,
        }
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
          var index = vm.temp_card.project_card_lists.indexOf(project_card_list)
          vm.temp_card.project_card_lists.splice(parseInt(index), 1)
          vm.resetTempCardList()
          vm.$emit("update-project", vm.project);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    deleteProjectCard(){
    	let vm = this
      this.axios.delete('projects/project_cards/'+vm.temp_card.id, {
        params: {
          deal_token: vm.$route.params.deal_token,
          project_card: vm.temp_card,
          project_list_id: vm.temp_card.project_list_id,
        }
      })
      .then(function(response) {
      	console.log('1')
        if (response.status == 200 && response['data']['status']== 'success') {
        	$.each(vm.project.project_lists,function(i,e){
        		console.log(e.id,vm.temp_card.project_list_id)
        		if(e.id == vm.temp_card.project_list_id){
        			var index = e.project_cards.indexOf(vm.temp_card)
		          e.project_cards.splice(parseInt(index), 1)
		          vm.showCardModal = false
		          vm.resetTempCard()
		          vm.$emit("update-project", vm.project);
        		}
        	})
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    deleteListItem(list,item){
    	let vm = this
      this.axios.delete('projects/project_card_list_items/'+item.id, {
        params: {
          deal_token: vm.$route.params.deal_token,
          project_card_list_item: item,
        }
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
          var index = list.project_card_list_items.indexOf(item)
          list.project_card_list_items.splice(parseInt(index), 1)
          const project = Object.assign({}, vm.project)
		      vm.$emit("update-project", project);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    resetTempComment(){
    	let vm = this
    	this.temp_comment = {
    		id: '',
    		content: '',
    		created_at: '',
    		project_card_id: this.temp_card.id,
    		user_token: vm.user.user_token,
    		loading: false,
    	}
    },
    addNewComment(){
    	let vm = this 
    	vm.temp_comment.loading = true

    	this.axios.post('projects/project_card_comments', {
        deal_token: vm.$route.params.deal_token,
        project_card_id: vm.temp_card.id,
        project_card_comment: vm.temp_comment
      })
      .then(function(response) {
        if (response.status == 200) {
          var new_comment = response['data']['data']['project_card_comment']
          vm.temp_card.project_card_comments.unshift(new_comment)
          // vm.editColumn('column_name',new_list.id)
          vm.resetTempComment()
          // vm.list_loading = false;
          vm.$emit("update-project", project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    // submitList(){
    //   let vm = this
    //   let oldList = getArrayItemById(vm.project.project_lists,vm.temp_list.id)
    //   oldList.name = vm.temp_list.name
    //   vm.editListTitle=false
    //   vm.resetTempList()
    // },
    doneItems(items){
      return items.filter(p => p.is_done === true)
    },
    doneItemsFromCards(cards){
    	let vm = this
    	let amount = 0
    	$.each(cards,function(i,e){
    		amount+= vm.doneItems(e.project_card_list_items).length
    	})
      return amount
    },
    totalItemsFromCards(cards){
      let vm = this
    	let amount = 0
    	$.each(cards,function(i,e){
    		amount+= e.project_card_list_items.length
    	})
      return amount
    },
    addNewList(){
      let vm = this
      const project = Object.assign({}, this.project)
      vm.resetTempList()

      vm.list_loading = true;

      this.axios.post('projects/project_lists', {
        deal_token: vm.$route.params.deal_token,
      })
      .then(function(response) {
        if (response.status == 200) {
          var new_list = response['data']['data']['project_list']
          project.project_lists.push(new_list)
          vm.editColumn('column_name',new_list.id)
          vm.resetTempList()
          vm.list_loading = false;
          vm.$emit("update-project", project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    updateProjectList(project_list){
      let vm = this
      this.axios.put('projects/project_lists/'+project_list.id, {
        project_list: project_list,
        deal_token: vm.$route.params.deal_token,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
        	project_list.work_days = response['data']['data']['project_list']['work_days']
          vm.$emit("update-project", vm.project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    deleteProjectList(project_list){
      let vm = this
      this.axios.delete('projects/project_lists/'+project_list.id, {
        params: {
          deal_token: vm.$route.params.deal_token,
        }
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
          var index = vm.project.project_lists.indexOf(project_list)
          vm.project.project_lists.splice(parseInt(index), 1)
          vm.resetTempList()
          vm.$emit("update-project", vm.project);
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },

    //以下是外層vue-smooth-dnd function
    onColumnDrop (dropResult) {
      let vm = this
      const project = Object.assign({}, this.project)
      project.project_lists = applyDrag(project.project_lists, dropResult)
      this.$emit("update-project", project); //防止prop打架，所以要往上傳遞，上一層要設定監聽
      this.axios.post('projects/project_lists/update_order', {
        project_lists: project.project_lists,
        deal_token: vm.$route.params.deal_token,
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.$emit("update-project", project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
      //this.project = project
    },

    onCardDrop (columnId, dropResult) {
    	console.log('e',dropResult)
    	let vm = this
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const project = Object.assign({}, this.project)
        const column = project.project_lists.filter(p => p.id === columnId)[0]
        const columnIndex = project.project_lists.indexOf(column)
        const newColumn = Object.assign({}, column)
        newColumn.project_cards = applyDrag(newColumn.project_cards, dropResult)
        project.project_lists.splice(columnIndex, 1, newColumn)

        this.$emit("update-project", project); //防止prop打架，所以要往上傳遞，上一層要設定監聽
        //this.project = project
        vm.axios.post('projects/project_cards/update_order', {
	        project_list_id: newColumn.id,
	        project_cards: newColumn.project_cards,
	        deal_token: vm.$route.params.deal_token,
	      })
	      .then(function(response) {
	        if (response.status == 200) {
	          vm.$emit("update-project", project);
	        } else {
	          console.log(response)
	        }
	      })
	      .catch(function(error) {
	        console.log('error:', error)
	      });
      }
      //this.project = project
    },
    getCardPayload (columnId) {
      return index => {
        return this.project.project_lists.filter(p => p.id === columnId)[0].project_cards[index]
      }
    },
    dragStart () {
      // console.log('drag started')
    },
    log (...params) {
      console.log(...params)
    },

    //以下是內層vue-smooth-dnd function，就是卡片點開後的那兩層
    onListDrop (dropResult) {
      let vm = this
      const project = Object.assign({}, this.project)
      vm.temp_card.project_card_lists = applyDrag(vm.temp_card.project_card_lists, dropResult)
      this.$emit("update-project", project); //防止prop打架，所以要往上傳遞，上一層要設定監聽
      //this.project = project
      vm.axios.post('projects/project_card_lists/update_order', {
        project_card_id: vm.temp_card.id,
        project_card_lists: vm.temp_card.project_card_lists,
        deal_token: vm.$route.params.deal_token,
      })
      .then(function(response) {
        if (response.status == 200) {
          // vm.$emit("update-project", project);
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    onItemDrop (listId, dropResult) {
      let vm = this
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const project = Object.assign({}, this.project)
        const list = vm.temp_card.project_card_lists.filter(p => p.id === listId)[0]
        const listIndex = vm.temp_card.project_card_lists.indexOf(list)
        console.log('list',list)
        const newList = Object.assign({}, list)
        newList.project_card_list_items = applyDrag(newList.project_card_list_items, dropResult)
        vm.temp_card.project_card_lists.splice(listIndex, 1, newList)

        console.log('newList',newList)

        this.$emit("update-project", project); //防止prop打架，所以要往上傳遞，上一層要設定監聽
        //this.project = project

        vm.axios.post('projects/project_card_list_items/update_order', {
	        project_card_list_id: newList.id,
	        project_card_list_items: newList.project_card_list_items ,
	        deal_token: vm.$route.params.deal_token,
	      })
	      .then(function(response) {
	        if (response.status == 200) {
	          // vm.$emit("update-project", project);
	        } else {
	          console.log(response)
	        }
	      })
	      .catch(function(error) {
	        console.log('error:', error)
	      });
      }
    },
    getItemPayload (listId) {
      return index => {
        return this.temp_card.project_card_lists.filter(p => p.id === listId)[0].project_card_list_items[index]
      }
    },
    log (...params) {
      console.log(...params)
    },

    //vue-smooth-dnd function end


    checkCard(card){
      console.log('checkCard checked',card.is_done)
    },
    goDeal(deal_token) {
      this.$router.push({ name: 'deal', params: { deal_token: deal_token } })
    },
    goDealManagement(deal_token){
      this.$router.push({ name: 'deal_management', params: { deal_token: deal_token } })
    },
    goDealFinance(deal_token) {
      this.$router.push({ name: 'deal_finance', params: { deal_token: deal_token } })
    },
  },
  filters: {
    moment_date: function(date) {
      moment.locale('zh-tw');
      if(moment(date).isSame(moment(),'year')){
      	return moment(date).format('MMM Do');
      }else{
      	return moment(date).format('YYYY MMM Do');
      }
    },
    moment: function(date) {
      moment.locale('zh-tw');
      if(moment(date).isSame(moment(),'year')){
      	return moment(date).format('MMM Do HH:mm');
      }else{
      	return moment(date).format('YYYY MMM Do HH:mm');
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// ProjectManageBoard.vue?4f66eb29